import { render, staticRenderFns } from "./PostCreate.vue?vue&type=template&id=3c719516&scoped=true"
import script from "./PostCreate.vue?vue&type=script&lang=js"
export * from "./PostCreate.vue?vue&type=script&lang=js"
import style0 from "./PostCreate.vue?vue&type=style&index=0&id=3c719516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c719516",
  null
  
)

export default component.exports